import MonetisationHealthPercentageBar from 'features/Health/components/MonetisationHealthPercentageBar';
import useStyles from 'features/Health/components/MonetisationHealthPercentageBars/MonetisationHealthPercentageBars.styles';

export type PercentageBar = {
  label: string;
  value: number;
  color: string;
};

type MonetisationHealthPercentageBarsProps = {
  percentageBars: PercentageBar[];
};

const MonetisationHealthPercentageBars = ({
  percentageBars,
}: MonetisationHealthPercentageBarsProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {percentageBars.map((child: PercentageBar, index) => (
        <MonetisationHealthPercentageBar
          key={index}
          label={child.label}
          value={child.value}
          color={child.color}
        />
      ))}
    </div>
  );
};

export default MonetisationHealthPercentageBars;
